export default __webpack_public_path__ + "static/media/malaysia.3228acc7.png";